<template>
  <component :is="$moduleConfiguration[module].orderForm" :module="module" :order-id="orderId"></component>
</template>

<script>
import OrderForm from '@/views/Orders/OrderForm.vue'
import OrderFormFits from '@/views/Orders/OrderFormFits.vue'
import OrderFormModular from '@/views/Orders/OrderFormModular.vue'
import OrderFormInsole from '@/views/Orders/OrderFormInsole.vue'

export default {
  name: 'OrderFormDynamic',
  components: {
    OrderForm,
    OrderFormFits,
    OrderFormModular,
    OrderFormInsole,
  },
  props: {
    orderId: {
      type: String,
      default: '',
    },
    module: {
      type: String,
      default: 'tailored',
    },
  },
  mounted() {
    const userInfo = this.$store.getters.user.userInfo
    if (!this.orderId && userInfo.type === 'I' && userInfo.level === '1') {
      this.$router.push('/forbidden')
    }
  },
}
</script>
